import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Terms = () => {



    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };

    return (
        <>

            <section className="legal-page" id="terms">
                <div className="container">
                    <div className="legal-header">
                        <h1>Terms and Conditions</h1>
                        <p className="last-updated">Last updated: November 10, 2025</p>
                    </div>

                    <div className="legal-content">
                        <section className="legal-section">
                            <h2>1. Introduction</h2>
                            <p>
                                Welcome to FeeZaap, a digital platform operated by
                                <strong> Napeans Technologies</strong>. By using this platform,
                                you agree to these Terms and Conditions.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>2. Service Overview</h2>
                            <ul>
                                <li>Manage students, batches, and staff</li>
                                <li>Process online fee payments</li>
                                <li>Send automated reminders</li>
                                <li>Reward parents with Zaap points</li>
                            </ul>
                        </section>

                        <section className="legal-section">
                            <h2>3. User Responsibilities</h2>
                            <ul>
                                <li>Maintain account security</li>
                                <li>Provide accurate information</li>
                                <li>Comply with payment schedules</li>
                            </ul>
                        </section>

                        <section className="legal-section">
                            <h2>4. Payments & Fees</h2>
                            <p>
                                Payments are transferred directly to the dance school account.
                                FeeZaap does not store funds.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>5. Refund & Cancellation</h2>
                            <p>
                                Refunds and cancellations are subject to the dance school's
                                discretion.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>6. Limitation of Liability</h2>
                            <p>
                                FeeZaap is not liable for indirect or consequential damages.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>7. Contact</h2>
                            <p>
                                Email:{" "}
                                <a href="mailto:mailus@feezaap.com">mailus@feezaap.com</a>
                            </p>
                        </section>
                    </div>
                </div>
            </section>

            {/* <footer className="footer">
                <div className="container">
                    <div className="footer-content">
                        <div className="footer-section">
                            <div className="footer-logo">
                                <img src="/assets/images/feezaap-logo.png" alt="FeeZaap Logo" />
                                <span>FeeZaap</span>
                            </div>
                            <p>Revolutionizing dance school fee management with secure, digital solutions.</p>
                        </div>

                        <div className="footer-section">
                            <h3>Quick Links</h3>
                            <ul>
                                <li><a href="#home">Home</a></li>
                                <li><a href="#features">Features</a></li>
                                <li><a href="#clients">Clients</a></li>
                                <li><a href="#about">About</a></li>
                                <li><a href="#contact">Contact</a></li>
                                <li><a href="#">Login</a></li>
                            </ul>
                        </div>

                        <div className="footer-section">
                            <h3>Legal</h3>
                            <ul>
                                <li>
                                    <Link to="/terms" onClick={scrollToTop}>
                                        Terms & Conditions
                                    </Link>
                                </li>

                                <li>
                                    <Link to="/privacy" onClick={scrollToTop}>
                                        Privacy Policy
                                    </Link>
                                </li>

                                <li><a href="https://napeans.com" target="_blank" rel="noopener noreferrer">Napeans Technologies</a></li>
                            </ul>
                        </div>

                        <div className="footer-section">
                            <h3>Download App</h3>
                            <div className="app-buttons">
                                <a href="https://play.google.com/store" className="app-button" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-google-play"></i>
                                    <span>Play Store</span>
                                </a>
                                <a href="https://apps.apple.com" className="app-button" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-app-store-ios"></i>
                                    <span>App Store</span>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="footer-bottom">
                        <p>
                            &copy; 2025 FeeZaap by <a href="https://napeans.com" target="_blank" rel="noopener noreferrer">Napeans Technologies</a>. All rights reserved.
                        </p>
                    </div>
                </div>
            </footer> */}
        </>
    );
};

export default Terms;
